import { Log } from '../../../../sentry';
export const sanitizeLogger = (breadcrumb) => {
    Log(Object.assign({ category: 'SanitizeHTMLError', level: 'warning' }, breadcrumb));
};
export const getRemoveBreadcrumb = (element, html) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if ('attribute' in element) {
        return {
            message: 'Removed unsafe attribute',
            data: {
                tag: ((_b = (_a = element.from) === null || _a === void 0 ? void 0 : _a.nodeName) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) || '',
                attr: ((_d = (_c = element.attribute) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.toLocaleLowerCase()) || '',
                value: ((_e = element.attribute) === null || _e === void 0 ? void 0 : _e.value) || '',
                html: html.slice(0, 150)
            }
        };
    }
    else {
        return {
            message: 'Removed unsafe tag',
            data: {
                tag: ((_g = (_f = element.element) === null || _f === void 0 ? void 0 : _f.nodeName) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase()) || '',
                html: html.slice(0, 150)
            }
        };
    }
};
export const getSanitizeStyleBreadcrumb = (value, type, style) => {
    if (type === 'parse') {
        return {
            message: 'Parsing error',
            data: {
                style,
                error: value
            }
        };
    }
    return {
        message: `Sanitize unsafe ${type}`,
        data: {
            [type]: value,
            style
        }
    };
};
